<template>
  <div>
    <!-- Modal Principal -->
    <b-modal
      id="modal-trend"
      size="xl"
      :title="$t('title.grafico-trend')"
      centered
    >
      <template #modal-header>
        <!-- Emulate built in modal header close button action -->
        <h5>{{ $t("title.grafico-trend") }}</h5>
        <p class="h4 btn m-0 p-0">
          <b-icon icon="x" @click="close()"></b-icon>
        </p>
      </template>

      <b-form v-if="grupo">
        <b-row class="mt-3">
          <!-- Conteúdo principal do trend-data -->
          <b-col sm="12" id="trend-data">
            <b-card
              bg-variant="light"
              :header="grupo.descricao"
              v-if="grupoLocal"
            >
              <b-row>
                <b-col>
                  <b-form-input
                    v-model="grupoLocal.titulo"
                    type="text"
                  ></b-form-input>
                </b-col>
              </b-row>
            </b-card>

            <b-card no-body class="mt-3">
              <b-tabs card bg-variant="light">
                <b-tab
                  v-for="(grafico, index) in grupo.graficos"
                  :key="grafico.id"
                  :title="grafico.descricao"
                  @click="updateTabIndex(index)"
                >
                  <b-row align-h="between" class="mb-2" align-v="center">
                    <b-col>
                      <b-form-input
                        v-model="grafico.titulo"
                        type="text"
                        size="sm"
                      ></b-form-input>
                    </b-col>
                    <b-col cols="auto">
                      <b-row align-v="center" align-h="end">
                        <b-col cols="1">
                          <b-form-checkbox
                            v-model="grafico.status"
                            name="check-button"
                            switch
                          >
                          </b-form-checkbox>
                        </b-col>
                        <b-col cols="auto">
                          <b-button variant="link">
                            <b-icon
                              icon="gear-fill"
                              class="button"
                              @click="showModalConfigurarGrafico(index)"
                              aria-hidden="true"
                            ></b-icon>
                          </b-button>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>

                  <b-row align-v="stretch">
                    <b-col sm="6">
                      <b-card
                        bg-variant="light"
                        :header="$t('header.caracteristicas')"
                      >
                        <b-button
                          size="sm"
                          @click="removerCaracteristicas"
                          :disabled="
                            selected_selecionadosCaracteristicas.length == 0
                          "
                          class="mb-2"
                        >
                          <b-icon icon="trash"></b-icon>
                          {{ $t("botoes.remover-selecionados") }}
                        </b-button>

                        <b-button
                          size="sm"
                          @click="removerTodasCaracteristicas"
                          :disabled="grafico.caracteristicas.length == 0"
                          class="mb-2 ml-2"
                        >
                          <b-icon icon="trash"></b-icon>
                          {{ $t("botoes.remover-todos") }}
                        </b-button>

                        <b-button
                          class="ml-2 mb-2"
                          @click="abrirModalCaracteristicas"
                          size="sm"
                        >
                          <b-icon icon="plus"></b-icon>
                          {{ $t("botoes.adicionar") }}
                        </b-button>

                        <b-table
                          v-if="grafico.caracteristicas.length > 0"
                          :items="grafico.caracteristicas"
                          :fields="fieldsCaracteristicas"
                          sticky-header
                          select-mode="range"
                          responsive="sm"
                          ref="selectableTableSelecionadosCaracteristicas"
                          selectable
                          bordered
                          hover
                          small
                          center
                          :current-page="currentPageSelecionadosCaracteristicas"
                          :per-page="perPage"
                          class="table-controles text-center mt-2 table-wrapper"
                          head-variant="light"
                          @row-selected="
                            onRowSelectedSelecionadosCaracteristicas
                          "
                        ></b-table>
                      </b-card>
                    </b-col>

                    <b-col sm="6">
                      <b-card
                        bg-variant="light"
                        :header="
                          grafico.controles.length +
                          ' ' +
                          $t('header.controles')
                        "
                        style="height: 100%"
                      >
                        <b-button
                          size="sm"
                          @click="removerControles"
                          :disabled="selected_selecionados.length == 0"
                          class="mb-2"
                        >
                          <b-icon icon="trash"></b-icon>
                          {{ $t("botoes.remover-selecionados") }}
                        </b-button>

                        <b-button
                          size="sm"
                          @click="removerTodosControles"
                          :disabled="grafico.controles.length == 0"
                          class="mb-2 ml-2"
                        >
                          <b-icon icon="trash"></b-icon>
                          {{ $t("botoes.remover-todos") }}
                        </b-button>

                        <b-button
                          @click="abrirModalControles"
                          size="sm"
                          class="mb-2 ml-2"
                        >
                          <b-icon icon="plus" aria-hidden="true"></b-icon>
                          {{ $t("botoes.adicionar") }}
                        </b-button>

                        <b-table
                          v-if="grafico.controles.length > 0"
                          :items="grafico.controles"
                          :fields="fields"
                          sticky-header
                          select-mode="range"
                          responsive="sm"
                          ref="selectableTableSelecionados"
                          selectable
                          bordered
                          hover
                          small
                          center
                          :current-page="currentPageSelecionados"
                          :per-page="perPage"
                          class="table-controles text-center mt-2 table-wrapper"
                          head-variant="light"
                          @row-selected="onRowSelectedSelecionados"
                        ></b-table>
                        <b-row>
                          <b-col>
                            <b-form-group>
                              <b-form-select
                                id="per-page-select"
                                v-model="perPage"
                                :options="pageOptions"
                                size="sm"
                              >
                              </b-form-select>
                            </b-form-group>
                          </b-col>
                          <b-col>
                            <b-pagination
                              size="sm"
                              v-model="currentPageSelecionados"
                              :total-rows="grafico.controles.length"
                              :per-page="perPage"
                              align="fill"
                            />
                          </b-col>
                        </b-row>
                      </b-card>
                    </b-col>
                  </b-row>
                </b-tab>
              </b-tabs>
            </b-card>
          </b-col>
        </b-row>
      </b-form>

      <b-alert show variant="danger" v-if="menssagem" class="mt-3">
        <ul v-if="menssagem">
          <li v-for="(e, key) in menssagem" :key="key">{{ e[0] }}</li>
        </ul>
      </b-alert>

      <template #modal-footer>
        <div class="w-100">
          <b-row align-v="center">
            <b-col cols="12" md="12">
              <b-button
                v-if="!carregando && !salvando"
                type="submit"
                variant="danger"
                class="float-right"
                @click="deletar()"
              >
                {{ $t("botoes.deletar") }}
              </b-button>

              <!-- <b-button
                v-if="!carregando"
                type="submit"
                variant="primary"
                class="float-right mr-3"
                @click="salvar()"
              >
                {{ $t("botoes.salvar") }}
              </b-button> -->

              <b-button
                variant="primary"
                class="float-right"
                v-if="salvando & !carregando"
                disabled
              >
                <b-icon icon="arrow-clockwise" animation="spin-pulse"></b-icon>
                {{ $t("botoes.salvando") }}
              </b-button>

              <b-button
                variant="primary"
                class="float-right"
                v-if="carregando & !salvando"
                disabled
              >
                <b-icon icon="arrow-clockwise" animation="spin-pulse"></b-icon>
                {{ $t("botoes.carregando") }}
              </b-button>

              <b-button
                v-if="!carregando && !salvando"
                type="submit"
                variant="primary"
                class="float-right mr-3"
                @click="gerarGrafico()"
              >
                {{ $t("botoes.gerar-graficos") }}
              </b-button>
            </b-col>
          </b-row>
        </div>
      </template>

      <trend-grafico-configuracao
        :grafico="grupo.graficos[indiceGraficoSelecionado]"
        v-if="grupo"
      />
      <modal-carregando-geral />
    </b-modal>

    <modal-selecao-caracteristicas
      ref="modalCaracteristicas"
      :caracteristicas="caracteristicas"
      :relatorio-id="grupoLocal ? grupoLocal.relatorio_id : 0"
      @adicionar-caracteristicas="adicionarCaracteristicasSelecionadas"
      @carregar-caracteristicas-iniciado="onCarregarCaracteristicasIniciado"
      @caracteristicas-carregadas="onCaracteristicasCarregadas"
      @erro-carregar-caracteristicas="onErroCarregarCaracteristicas"
    />

    <modal-selecao-controles
      ref="modalControles"
      :controles="controles"
      :relatorio-id="grupoLocal ? grupoLocal.relatorio_id : 0"
      @adicionar-controles="adicionarControlesSelecionados"
      @carregar-controles-iniciado="onCarregarControlesIniciado"
      @controles-carregados="onControlesCarregados"
      @erro-carregar-controles="onErroCarregarControles"
      @excluir-controle="excluirControle"
    />
  </div>
</template>

<script>
import ModalCarregandoGeral from "@/components/modal/CarregandoGeral.vue";
import ModalSelecaoCaracteristicas from "./ModalSelecaoCaracteristicas.vue";
import ModalSelecaoControles from "./ModalSelecaoControles.vue";
import TrendGraficoConfiguracao from "./TrendGraficoConfiguracao.vue";

export default {
  name: "TrendModal",
  props: {
    grupo: null,
  },
  components: {
    ModalCarregandoGeral,
    TrendGraficoConfiguracao,
    ModalSelecaoControles,
    ModalSelecaoCaracteristicas,
  },
  data() {
    return {
      grupoLocal: null,
      optionsCaracteristicas: [],
      caracteristica_selecionada: null,
      optionsCaracteristicasAtivas: [],
      caracteristica_ativa_selecionada: null,
      tabIndex: 0,
      show: true,
      menssagem: null,
      carregando: null,
      salvando: false,

      controles: [],
      controles_selecionados: [],

      totalRows: 1,
      currentPage: 1,
      currentPageSelecionados: 1,
      perPage: 15,
      fields: [{ key: "controle_id", label: "cod" }, "data"],
      selected: [],
      selected_selecionados: [],

      caracteristicas: [],
      caracteristicas_selecionados: [],

      totalRowsCaracteristicas: 1,
      currentPageCaracteristicas: 1,
      currentPageSelecionadosCaracteristicas: 1,
      perPageCaracteristicas: 15,
      fieldsCaracteristicas: ["elemento", "ax"],
      selectedCaracteristicas: [],
      selected_selecionadosCaracteristicas: [],

      indiceGraficoSelecionado: 0,

      pageOptions: [
        { value: 5, text: this.$t("paginacao.5-itens-por-pagina") },
        { value: 10, text: this.$t("paginacao.10-itens-por-pagina") },
        { value: 15, text: this.$t("paginacao.15-itens-por-pagina") },
        { value: 100, text: this.$t("paginacao.100-itens-por-pagina") },
      ],
    };
  },
  methods: {
    // Métodos para controlar os novos modais
    abrirModalCaracteristicas() {
      this.$bvModal.show("modal-selecao-caracteristicas");
    },
    fecharModalCaracteristicas() {
      this.$bvModal.hide("modal-selecao-caracteristicas");
    },
    abrirModalControles() {
      this.$bvModal.show("modal-selecao-controles");
    },
    fecharModalControles() {
      this.$bvModal.hide("modal-selecao-controles");
    },

    onCarregarCaracteristicasIniciado() {
      //this.$bvModal.show("modal-carregando-geral");
    },
    onCaracteristicasCarregadas(caracteristicas) {
      this.caracteristicas = caracteristicas;
      //this.$bvModal.hide("modal-carregando-geral");
    },
    onErroCarregarCaracteristicas(error) {
      console.log(error);
      //this.$bvModal.hide("modal-carregando-geral");
    },

    adicionarCaracteristicasSelecionadas(caracteristicas) {
      caracteristicas.forEach((caracteristica) => {
        this.caracteristicas.push(caracteristica);
        this.grupoLocal.graficos[this.tabIndex].caracteristicas.push(
          caracteristica
        );
      });
    },

    adicionarControlesSelecionados(controles) {
      controles.forEach((controle) => {
        this.controles_selecionados.push(controle);
        this.grupoLocal.graficos[this.tabIndex].controles.push(controle);
      });
    },
    onCarregarControlesIniciado() {
      this.carregando = true;
      this.menssagem = null;
      this.controles = [];
    },
    onControlesCarregados(controles) {
      this.controles = controles;
      this.totalRows = controles.length;
      this.carregando = false;
    },
    onErroCarregarControles(error) {
      this.menssagem = error;
      this.carregando = false;
    },
    excluirControle(cod) {
      // Implementar lógica de exclusão se necessário
      console.log("Excluir controle:", cod);
    },

    showModalConfigurarGrafico(indice) {
      this.indiceGraficoSelecionado = indice;
      this.$bvModal.show("modal-trend-grafico-configuracao");
    },
    gerarGrafico() {
      this.$emit("gerarGrafico", this.grupo.id);
      this.close();
    },
    updateTabIndex(index) {
      this.tabIndex = index;
    },
    carregarCaracteristicas() {
      //this.$bvModal.show("modal-carregando-geral");
      this.$http
        .get("api/relatorio/caracteristicas/" + this.grupoLocal.relatorio_id)
        .then((response) => {
          this.caracteristicas = [];
          response.data.forEach((caract) => {
            this.caracteristicas.push({
              elemento: caract.ponto.toUpperCase(),
              ax: caract.ax.toUpperCase(),
            });
          });
          //this.$bvModal.hide("modal-carregando-geral");
        })
        .catch((errors) => {
          console.log(errors);
          //this.$bvModal.hide("modal-carregando-geral");
        });
    },
    carregarControles() {
      this.carregando = true;
      this.menssagem = null;
      this.controles = [];

      this.$http
        .get("api/relatorio/controles/" + this.grupoLocal.relatorio_id)
        .then((response) => {
          this.controles_bd = response.data;
          this.controles = [];
          this.controles_bd.forEach((controle) => {
            const d = new Date(controle.data).toLocaleDateString("pt-br");
            const h = new Date(controle.data).toLocaleTimeString("pt-br");
            this.controles.push({
              ativo: controle.ativo ? true : false,
              controle_id: controle.id,
              data: d + " " + h,
            });
          });

          this.totalRows = this.controles.length;
          this.carregando = false;
        })
        .catch((errors) => {
          this.menssagem = errors.response;
          this.carregando = false;
        });
    },
    makeToast(
      variant = null,
      msg = this.$t("toast.operacao-realizada-com-sucesso")
    ) {
      this.$bvToast.toast(msg, {
        title: this.$t("toast.sucesso"),
        variant: variant,
        solid: true,
      });
    },
    close() {
      this.$bvModal.hide("modal-trend");
    },
    adicinarControles() {
      this.selected.forEach((controle) => {
        this.controles_selecionados.push(controle);
        this.grupoLocal.graficos[this.tabIndex].controles.push(controle);
      });
      this.clearSelected();
      this.fecharModalControles();
    },
    removerControles() {
      this.selected_selecionados.forEach((controle) => {
        this.grupoLocal.graficos[this.tabIndex].controles =
          this.grupoLocal.graficos[this.tabIndex].controles.filter(
            (controle_selecionado) =>
              controle_selecionado.controle_id != controle.controle_id
          );
      });
    },
    removerTodosControles() {
      this.grupoLocal.graficos[this.tabIndex].controles = [];
      this.controles_selecionados = [];
    },
    removerTodasCaracteristicas() {
      this.grupoLocal.graficos[this.tabIndex].caracteristicas = [];
      this.caracteristicas_selecionados = [];
    },
    adicinarCaracteristicas() {
      this.selectedCaracteristicas.forEach((caracteristica) => {
        this.caracteristicas_selecionados.push(caracteristica);
        this.grupoLocal.graficos[this.tabIndex].caracteristicas.push(
          caracteristica
        );
      });
      this.clearSelectedCaracteristicas();
      this.fecharModalCaracteristicas();
    },
    removerCaracteristicas() {
      this.selected_selecionadosCaracteristicas.forEach((caracteristica) => {
        this.grupoLocal.graficos[this.tabIndex].caracteristicas =
          this.grupoLocal.graficos[this.tabIndex].caracteristicas.filter(
            (caracteristica_selecionado) => {
              return (
                caracteristica_selecionado.elemento !=
                  caracteristica.elemento ||
                caracteristica_selecionado.ax != caracteristica.ax
              );
            }
          );
      });
      this.caracteristicas_selecionados = [];
    },

    onRowSelected(items) {
      this.selected = items;
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows();
    },
    clearSelected() {
      this.$refs.selectableTable.clearSelected();
    },
    onRowSelectedSelecionados(items) {
      this.selected_selecionados = items;
    },

    onRowSelectedCaracteristicas(items) {
      this.selectedCaracteristicas = items;
    },
    selectAllRowsCaracteristicas() {
      this.$refs.selectableTableCaracteristicas.selectAllRows();
    },
    clearSelectedCaracteristicas() {
      this.$refs.selectableTableCaracteristicas.clearSelected();
    },
    onRowSelectedSelecionadosCaracteristicas(items) {
      this.selected_selecionadosCaracteristicas = items;
    },
    salvar() {
      this.menssagem = null;
      this.salvando = true;

      let config = {
        headers: {
          Accept: "application/json",
        },
      };

      const data = { ...this.grupoLocal, _method: "patch" };

      this.$http
        .post("api/trend-grupo/" + this.grupoLocal.id, data, config)
        .then(() => {
          //this.makeToast("success", this.$t("toast.atualizacao-realizada-com-sucesso"));
          this.salvando = false;
          //this.$emit("listaMudou");
        })
        .catch((errors) => {
          this.menssagem = errors.response.data.errors;
          this.salvando = false;
        });
    },
    deletar() {
      let confirmacao = confirm(
        this.$t("confirmacao.tem-certeza-que-deseja-remover-esse-apresentacao")
      );

      if (!confirmacao) {
        return false;
      }

      let formData = new FormData();
      formData.append("_method", "delete");

      let config = {
        headers: {
          "Content-Type": "multipart/form-data",
          Accept: "application/json",
        },
      };

      this.$http
        .post("api/trend-grupo/" + this.grupoLocal.id, formData, config)
        .then(() => {
          this.makeToast("success");
          this.$bvModal.hide("modal-trend");
          this.carregando = false;
          this.$emit("listaMudou");
        })
        .catch((errors) => {
          this.menssagem = errors.response.data.errors;
          this.carregando = false;
        });
    },
  },

  computed: {
    ano: {
      get() {
        return this.$store.state.ano;
      },
    },
    semana: {
      get() {
        return this.$store.state.semana;
      },
    },
  },
  mounted() {
    if (this.grupo) {
      this.grupoLocal = { ...this.grupo };
      this.carregarCaracteristicas();
      this.carregarControles();
    }
  },
  watch: {
    grupo: function (grupo) {
      if (grupo) {
        this.grupoLocal = { ...grupo };
        this.carregarCaracteristicas();
        this.carregarControles();
      }
    },
    grupoLocal: {
      deep: true,
      handler() {
        this.salvar();
      },
    },
  },
};
</script>

<style scoped>
.table-wrapper {
  font-size: 12px !important;
}

.container-caracteristicas {
  height: 100%;
}

.text-radio {
  font-size: 14px;
}
</style>
